import { SET_EDITUSER } from '../actions';

const useredit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITUSER:
      return [...action.value];  
    default: return state;
  }
}

export default useredit;
